// extracted by mini-css-extract-plugin
export var bodySections = "_dd-8";
export var gray = "_dd-7";
export var green = "_dd-4";
export var iconContainer = "_dd-9";
export var iconWidgetContainer = "_dd-1";
export var phoneIcon = "_dd-2";
export var red = "_dd-5";
export var statusDot = "_dd-3";
export var widgetContainer = "_dd-0";
export var yellow = "_dd-6";